import * as _ from "lodash"
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_CustomerRoleRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Customer_Role} from "../PA.Core/PAdbSchema";
import {SourceCustomerTypeBO} from "./SourceCustomerTypeBO";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class SourceCustomerTypeBOValidations {

    static async ValidateFields(aBO: SourceCustomerTypeBO): Promise<void> {
        const self = this;
        let dbContext = new PAdbContext({})
        let rowPresent: any = {}
        let allDuplicateIDNameRows: any[] = []
        let allDuplicateIDRows: any[] = []
        let customerTypeRows = await dbContext.findAll(esWB_Customer_Role, {where: {DELETED_IND: {neq: '1'}}})
        let userContext = PAEnvironment.getValue(PAEnvironment.UserContext, 'UserContext')
        let bHasRole = userContext.hasRoleId("Customer_Data_Editor")


        if (_.isEmpty(aBO.WB_SourceCustomerType.cif.ROLE_ID) && _.isEmpty(aBO.WB_SourceCustomerType.cif.ROLE_NAME) && !bHasRole){
            self.addMessage(aBO, "viewerRoleCreate", 'Only Users with Editor Role can Create a new Source Customer Type')
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("viewerRoleCreate")
        }

        if(!bHasRole){
            self.addMessage(aBO, "viewerRoleSave", 'Only Users with Editor Role can update a Source Customer Type')
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("viewerRoleSave")
        }

        if (_.isEmpty(aBO.WB_SourceCustomerType.cif.ROLE_ID))
        {
            self.addMessage(aBO, "emptyID", 'Source Customer Type ID cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyID")
        if (_.isEmpty(aBO.WB_SourceCustomerType.cif.ROLE_NAME))
        {
            self.addMessage(aBO, "emptyName", 'Source Customer Type Name cannot be empty')
        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyName")


        if(aBO.WB_SourceCustomerType.cif.WB_MDSET_ID===0){
            self.addMessage(aBO, "requiredMDSet", 'Please select a MD Set')
        } else {
            aBO.ValidateMessageProvider.removeMessage("requiredMDSet")
        }

        if(aBO.WB_SourceCustomerType.cif.WB_CUSTM_ID===0){
            self.addMessage(aBO, "requiredCustType", 'Please select a Customer Type')
        } else {
            aBO.ValidateMessageProvider.removeMessage("requiredCustType")
        }


        _.forEach(customerTypeRows, (row: WB_CustomerRoleRow) => {

            if (row.cif.WB_CUSTROLE_ID !== aBO.WB_SourceCustomerType.cif.WB_CUSTROLE_ID &&
                row.cif.ROLE_ID === aBO.WB_SourceCustomerType.cif.ROLE_ID &&
                _.toLower(row.cif.ROLE_NAME) === _.toLower(aBO.WB_SourceCustomerType.cif.ROLE_NAME)) {
                rowPresent = {
                    name: row.cif.ROLE_NAME,
                    id: row.cif.ROLE_ID
                }
                allDuplicateIDNameRows.push(rowPresent)
            }
            else if (row.cif.WB_CUSTROLE_ID !== aBO.WB_SourceCustomerType.cif.WB_CUSTROLE_ID &&
                row.cif.ROLE_ID === aBO.WB_SourceCustomerType.cif.ROLE_ID ){
                rowPresent = {
                    name: row.cif.ROLE_NAME,
                    id: row.cif.ROLE_ID
                }
                allDuplicateIDRows.push(rowPresent)
            }
        })

        if (!_.isEmpty(allDuplicateIDNameRows)) {
            self.addMessage(aBO, "duplicateIDName", 'There is an existing Source Customer Type with the same ID and Name' +
                '\nSource Customer Type Name:  ' + rowPresent?.name +
                '\nSource Customer Type ID: ' + rowPresent?.id
            )
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateIDName")
        }

        if (!_.isEmpty(allDuplicateIDRows)) {
            self.addMessage(aBO, "duplicateID", 'There is an existing Source Customer Type with the same ID' +
                '\nSource Customer Type ID: ' + rowPresent?.id
            )
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateID")
        }


    }

    private static addMessage(aBO: SourceCustomerTypeBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}